import { render, staticRenderFns } from "./B_fake.vue?vue&type=template&id=79d286a1&scoped=true&"
import script from "./B_fake.vue?vue&type=script&lang=js&"
export * from "./B_fake.vue?vue&type=script&lang=js&"
import style0 from "./B_fake.vue?vue&type=style&index=0&id=79d286a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d286a1",
  null
  
)

export default component.exports